import { Link } from "react-router-dom";
import { Mail, Phone, ArrowUpRight } from "lucide-react";
import { NAV_LINKS } from "@/lib/content";

const OFFERINGS_LINKS = [
  { to: "/offerings", label: "All Offerings" },
  { to: "/offerings#consulting", label: "Consulting" },
  { to: "/offerings#speaking", label: "Speaking" },
  { to: "/offerings#training", label: "Training" },
  { to: "/offerings#ai", label: "AI" },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[var(--tmg-obsidian)] text-[var(--tmg-ivory)]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-20 py-20">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-10 bg-[var(--tmg-gold)] text-[var(--tmg-obsidian)] flex items-center justify-center font-display font-bold text-xs tracking-tight">
                TMG
              </span>
              <span className="font-display text-xl font-semibold">
                TMG Consulting Group
              </span>
            </div>
            <p className="text-sm text-white/70 max-w-md leading-relaxed">
              TMG Consulting Group helps employers, communities, and growing
              businesses develop their leaders, strengthen their workforce, and
              build systems that last.
            </p>
            <div className="mt-8">
              <p className="tmg-overline-gold mb-3">Contact</p>
              <a
                href="mailto:info@tmariegreene.com"
                data-testid="footer-email-link"
                className="inline-flex items-center gap-2 text-sm hover:text-[var(--tmg-gold)] transition-colors"
              >
                <Mail className="w-4 h-4" /> info@tmariegreene.com
              </a>
              <a
                href="tel:+13137431904"
                data-testid="footer-phone-link"
                className="mt-3 flex items-center gap-2 text-sm hover:text-[var(--tmg-gold)] transition-colors"
              >
                <Phone className="w-4 h-4" /> (313) 743-1904
              </a>
            </div>
          </div>

          <div className="lg:col-span-2">
            <p className="tmg-overline-gold mb-5">Navigate</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-white/75 hover:text-[var(--tmg-gold)] transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="tmg-overline-gold mb-5">Offerings</p>
            <ul className="space-y-3">
              {OFFERINGS_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-white/75 hover:text-[var(--tmg-gold)] transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="tmg-overline-gold mb-5">Start Here</p>
            <Link
              to="/ai-readiness"
              data-testid="footer-checklist-link"
              className="block bg-white/[0.04] border border-[var(--tmg-gold)]/40 p-5 hover:border-[var(--tmg-gold)] transition-colors mb-4"
            >
              <p className="font-mono-sm text-[10px] uppercase tracking-[0.2em] text-[var(--tmg-gold)] mb-2">
                Free Tool
              </p>
              <p className="font-display text-base font-semibold leading-tight">
                AI Readiness Checklist →
              </p>
            </Link>
            <Link
              to="/book-call"
              data-testid="footer-book-call-btn"
              className="inline-flex items-center gap-2 text-sm border-b border-[var(--tmg-gold)] pb-1 hover:text-[var(--tmg-gold)] transition-colors"
            >
              Book a Discovery Call <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-xs text-white/50">
          <p>© 2026 TMG Consulting Group · Ypsilanti, Michigan</p>
          <p className="font-mono-sm">
            Powered by{" "}
            <span className="text-[var(--tmg-gold)]">Opturna</span> — AI Systems &
            Automation
          </p>
        </div>
      </div>
    </footer>
  );
}
